/**
 * 銀行振込での返金が必要なときに、CS に「口座情報メール」を送るための mailto URL を生成する。
 * subject / body をクエリで仕込んでおき、メーラーで開いた時に空欄を埋めるだけにする。
 *
 * DOM に依存しない純粋関数なので、テストから直接組み立てを確かめられる。
 */
export const buildBankInfoMailto = (orderCode: string): string => {
  const subject = `【口座情報】注文 ${orderCode} のキャンセル返金口座について`;
  const body = [
    `ご注文 ${orderCode} のキャンセルに伴う返金口座をお知らせします。`,
    "",
    "金融機関名:",
    "店名:",
    "口座種別: (普通 / 当座)",
    "口座番号:",
    "口座名義:",
    "",
    "ご確認のほどよろしくお願いいたします。",
  ].join("\n");
  return `mailto:c-support@survaq.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
